<template>
  <div class="icons-select">
    <span class="mr-3">
      {{ label }}
    </span>

    <template v-for="item in choices">
      <i @click="handleItemClick(item)"
         :class="getIconClass(item)"
         :key="`select-item-${item.value}`">
      </i>
    </template>
  </div>
</template>

<script>
export default {
  name: 'icons-select',

  props: {
    label: {
      type: String,
      default: 'Label'
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    choices: {
      type: Array,
      default: () => [
        {value: 'empty', text: 'Empty'},
      ],
    },

    value: {
      default: null,
    },
  },

  data() {
    return {
      internalValue: this.defaultSections || this.choices[0].value,
    };
  },

  methods: {
    handleItemClick(item) {
      if(!this.disabled) {
        this.internalValue = item.value;
        this.$emit('input', this.internalValue);
      }
    },

    getIconClass(item) {
      const disabled = this.disabled ? 'disabled' : '';
      const selected = item.value === this.value ? 'selected' : '';

      return `choice-icon ${selected} ${disabled} ${item.iconClass}`;
    },
  },
}
</script>

<style scoped lang="scss">
  .icons-select {
    display: flex;
    height: 20px;
    line-height: 20px;
    margin-bottom: 0;
    align-items: center;
  }

  .choice-icon {
    cursor: pointer;
    color: #2d5f7b;
    &:not(:last-child) {
      margin-right: 1rem;
    }
  }

  .choice-icon.selected,
  .choice-icon:hover {
    color: #47a8c6;
  }

  .choice-icon.disabled {
    cursor: default;
    color: #767676;
  }

  .choice-icon.disabled.selected {
    color: #c2c2c2;
  }
</style>
